module.exports = {
    SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
    ADMIN:       'ROLE_ADMIN',
    MANAGER:     'ROLE_MANAGER',
    TRAINER:     'ROLE_TRAINER',
    USER:        'ROLE_USER'
};


